import { TextTrack } from 'vidstack'
const SYNC_PROGRESS_INTERVAL = 5

const EducationVideoPlayer = {
  mounted() {
    this.updated()
  },

  updated() {
    this.destroyed()

    if (this.el.getAttribute('data-hide-interstitial')) {
      this.liveSocket.execJS(this.el, this.el.getAttribute('data-hide-interstitial'))
    }

    const video = this.el.querySelector('media-player')

    this.handleEvent('player:error', () => {
      this.player?.pause()
      this.errors()
    })

    this.handleEvent('player:config', (data) => {
      this._setup(video, data)
    })

    this.handleEvent('player:resume', (data) => {
      if (data) {
        this.resume(parseInt(data.videoTimeWatched, 10))
      }
    })
  },

  disconnected() {
    this.player?.pause()
    this.errors()
  },

  destroyed() {
    this.CURRENT_VIDEO_STATE = null
    this.MAX_WATCHED_TIME = 0

    clearTimeout(this.resumeTimeout)
  },

  errors() {
    const error = document.querySelector('#content-container-error')

    if (error) {
      error.style.display = 'block'
    }
  },

  resumeButton(show) {
    const resumeButton = document.querySelector('#content-container-player-resume')

    if (resumeButton) {
      resumeButton.style.display = show ? 'block' : 'none'
    }
  },

  _setup(element, { data, source }) {
    this.MAX_WATCHED_TIME = parseInt(data ? data.videoTimeWatched : 0, 10)
    this.CURRENT_VIDEO_STATE = null

    this._setupPlayer(element)
    this._setupSource(element, source)
  },

  _setupPlayer(element, opts = {}) {
    this.player = element

    this.player.addEventListener('can-play', () => {
      this.resumeButton(true)
    })

    this.player.addEventListener('media-seek-request', (event) => {
      if (event.detail > this.MAX_WATCHED_TIME) {
        this.player.currentTime = this.MAX_WATCHED_TIME;
        event.preventDefault()
      }
    })

    this.player.querySelector('media-time-slider').addEventListener('media-seek-request', (event) => {
      if (event.detail > this.MAX_WATCHED_TIME) {
        this.player.currentTime = this.MAX_WATCHED_TIME;
        event.preventDefault()
      }
    })

    // eslint-disable-next-line complexity
    this.player.addEventListener('play', () => {
      if (this.CURRENT_VIDEO_STATE === 'START' || this.CURRENT_VIDEO_STATE === 'RESUME') {
        return
      }

      if (this.CURRENT_VIDEO_STATE === null) {
        this.updateUserWatchActivity('watch:start')
        this.resumeButton(false)
        this.CURRENT_VIDEO_STATE = 'START'
      } else {
        this.updateUserWatchActivity('watch:resume')
        this.CURRENT_VIDEO_STATE = 'RESUME'
      }
    })

    this.player.addEventListener('media-pause-request', () => {
      const currentTime = Math.floor(this.player.currentTime);

      if (this.CURRENT_VIDEO_STATE === 'PAUSE' || currentTime === Math.floor(this.player.duration)) {
        return
      }

      this.updateUserWatchActivity('watch:pause');
      this.updateUserWatchState(currentTime)
      this.CURRENT_VIDEO_STATE = 'PAUSE';
    })

    this.player.addEventListener('ended', () => {
      const currentTime = Math.floor(this.player.currentTime);

      if (this.CURRENT_VIDEO_STATE !== null && this.CURRENT_VIDEO_STATE !== 'ENDED') {
        this.liveSocket.execJS(this.el, this.el.getAttribute('data-show-interstitial'))

        this.updateUserWatchActivity('watch:finish');
        this.updateUserWatchState(currentTime)
        this.CURRENT_VIDEO_STATE = 'ENDED';
      }
    })

    this.player.subscribe(({ playing, currentTime }) => {
      const timestamp = Math.floor(currentTime);
      const heartbeat = timestamp % SYNC_PROGRESS_INTERVAL;

      if (playing && heartbeat === 0 && timestamp > this.MAX_WATCHED_TIME) {
        this.MAX_WATCHED_TIME = timestamp
        this.updateUserWatchState(timestamp)
      }
    })

    this.player.querySelector('[data-event-resume]')?.addEventListener('click', (event) => {
      this.player.remoteControl.seek(this.MAX_WATCHED_TIME, event)
      setTimeout(() => this.player.remoteControl.play(event), 150)
    })
  },

  _setupSource(element, source) {
    element.textTracks.clear()
    element.src = source.itemConfigVideo

    source.itemConfigVideoTracks.forEach((track) => {
      element.textTracks.add(new TextTrack({
        label: track.label,
        kind: 'subtitles',
        src: track.source,
        srclang: track.source,
        type: 'vtt',
      }))
    })
  },

  updateVideoState(timecode) {
    const progress = document.querySelector('#player-save-progress')

    if (progress) {
      progress.innerText = timecode
    }
  },

  updateUserWatchActivity(action) {
    const timecode = Math.floor(this.player.currentTime)

    if (!this.liveSocket.isConnected()) {
      this.player?.pause()
      this.errors()
    }

    this.pushEventTo('#content-container-player', 'track', { action, timecode }, (response, _ref) => {
      if (response.success === false) {
        this.player?.pause()
        this.errors()
      }

      if (response.success === true) {
        this.updateVideoState(response.timecode)
      }
    })
  },

  updateUserWatchState(timestamp) {
    if (!this.liveSocket.isConnected()) {
      this.player?.pause()
      this.errors()
    }

    this.pushEventTo('#content-container-player', 'watch', { timestamp }, (response, _ref) => {
      console.log(response)
      if (response.success === false) {
        this.player?.pause()
        this.errors()
      }

      if (response.success === true) {
        this.updateVideoState(response.timecode)
      }
    })
  },
}

export default EducationVideoPlayer
